import { FC, useEffect, useRef, useState } from "react";
import { Table, Button, Confirm, Modal, Input } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { SortableColumns } from "./ScalesVM";
import ScalesVM from "./ScalesVM";
interface Props {
    viewModel: ScalesVM;
}


const Scales: FC<Props> = observer(({ viewModel }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [searchTerm, setSearchTerm] = useState("");

    // Загрузка данных при монтировании
    useEffect(() => {
        viewModel.fetchData();
        return () => viewModel.dispose();
    }, [viewModel]);

    // Фильтрация и сортировка данных
    const filteredData = searchTerm
        ? viewModel.filterData(searchTerm)
        : viewModel.sortedData;

    return (
        <div ref={containerRef} style={{ height: 400, overflowY: "auto" }}>
            {/* Поисковая строка */}
            <Input
                icon="search"
                placeholder="Поиск по названию, пользователю или ID..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ marginBottom: 20, width: "100%" }}
            />

            {/* Таблица */}
            <Table sortable celled compact>
                <Table.Header>
                    <Table.Row style={{ position: "sticky", top: 0, zIndex: 1 }}>
                        <Table.HeaderCell
                            sorted={viewModel.sortedColumn === SortableColumns.id ? viewModel.sortDirection: null}
                            onClick={() => viewModel.sortTable(SortableColumns.id)}
                        >
                            ID
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            sorted={viewModel.sortedColumn === SortableColumns.name ? viewModel.sortDirection : null}
                            onClick={() => viewModel.sortTable(SortableColumns.name)}
                        >
                            Название
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            sorted={viewModel.sortedColumn === SortableColumns.customer ? viewModel.sortDirection : null}
                            onClick={() => viewModel.sortTable(SortableColumns.customer)}
                        >
                            Пользователь
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            sorted={viewModel.sortedColumn === SortableColumns.activation ? viewModel.sortDirection : null}
                            onClick={() => viewModel.sortTable(SortableColumns.activation)}
                        >
                            Активация
                        </Table.HeaderCell>
                        <Table.HeaderCell>Действия</Table.HeaderCell>
                    </Table.Row>

                </Table.Header>

                <Table.Body>
                    {filteredData.length === 0 ? (
                        <Table.Row>
                            <Table.Cell colSpan="5" textAlign="center">
                                {searchTerm ? "Ничего не найдено" : "Нет данных"}
                            </Table.Cell>
                        </Table.Row>
                    ) : (
                        filteredData.map((scale) => (
                            <Table.Row key={scale.id}>
                                <Table.Cell>{scale.id}</Table.Cell>
                                <Table.Cell>{scale.name}</Table.Cell>
                                <Table.Cell>{scale.user?.name || "-"}</Table.Cell>
                                <Table.Cell>
                                    {new Date(scale.expiryDate).toLocaleDateString('ru-RU')}
                                </Table.Cell>
                                <Table.Cell>
                                    <Button
                                        icon="trash"
                                        color="red"
                                        onClick={() => viewModel.openConfirmDialog(scale.id)}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        ))
                    )}
                </Table.Body>

                <Table.Footer fullWidth>
                    <Table.Row>
                        <Table.HeaderCell colSpan="5">
                            <Button
                                primary
                                fluid
                                icon="plus"
                                content="Добавить"
                                onClick={() => viewModel.createScale()}
                            />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Footer>
            </Table>

            {/* Диалог подтверждения удаления */}
            <Confirm
                open={viewModel.confirmEnabled}
                header="Подтверждение удаления"
                content="Вы уверены, что хотите удалить эту запись?"
                confirmButton="Удалить"
                cancelButton="Отмена"
                onConfirm={viewModel.deleteScale}
                onCancel={viewModel.closeConfirmDialog}
            />

            {/* Модальное окно */}
            <Modal
                open={viewModel.modalOpened}
                onClose={() => viewModel.setModal("", null, false)}
                closeIcon
            >
                <Modal.Header>{viewModel.modalHeader}</Modal.Header>
                <Modal.Content>{viewModel.modalContent}</Modal.Content>
            </Modal>
        </div>
    );
});

export default Scales;
// const Scales: FC<Props> = ({ viewModel }) => {

//let reference = useRef();

//useEffect(() => {
//    viewModel.fetchData();
//}, []);

//return (
//    <div ref={reference} style={{ height: 400, overflowY: "scroll" }}>
//        <Table sortable celled compact style={{borderTopWidth: 0} }>
//            <Table.Header >

//                    <Table.Row style={{position: "sticky", top: 0, zIndex: 1} }>
//                    <Table.HeaderCell
//                        sorted={viewModel.sortedColumn === SortableColumns.id ? viewModel.sortDirection : null}
//                        onClick={() => viewModel.sortTable(SortableColumns.id)}
//                    >
//                        ID
//                    </Table.HeaderCell>

//                    <Table.HeaderCell
//                        sorted={viewModel.sortedColumn === SortableColumns.name ? viewModel.sortDirection : null}
//                        onClick={() => viewModel.sortTable(SortableColumns.name)}
//                    >
//                        Название
//                    </Table.HeaderCell>

//                    <Table.HeaderCell
//                        sorted={viewModel.sortedColumn === SortableColumns.customer ? viewModel.sortDirection : null}
//                        onClick={() => viewModel.sortTable(SortableColumns.customer)}
//                    >
//                        Пользователь
//                    </Table.HeaderCell>

//                    <Table.HeaderCell
//                        sorted={viewModel.sortedColumn === SortableColumns.activation ? viewModel.sortDirection : null}
//                        onClick={() => viewModel.sortTable(SortableColumns.activation)}
//                    >
//                        Активация
//                    </Table.HeaderCell>

//                        <Table.HeaderCell colSpan='2'>Действия</Table.HeaderCell>
//                    </Table.Row>
//                </Table.Header>
//            <Table.Body>
//                {viewModel.dataTable.length === 0
//                    ?
//                    <Table.Row>
//                        <Table.Cell colSpan="5" textAlign="center">
//                            <span>Пусто</span>
//                        </Table.Cell>

//                    </Table.Row>

//                    :
//                    viewModel.dataTable.map((scale, index) => (
//                        <Table.Row key={scale.id}>
//                            <Table.Cell collapsing>{scale.id}</Table.Cell>
//                            <Table.Cell>{scale.name}</Table.Cell>
//                            <Table.Cell>{scale.user ? scale.user.name : ''}</Table.Cell>
//                            <Table.Cell>{new Date(scale.expiryDate).toLocaleString('ru', { day: '2-digit', month: '2-digit', year: 'numeric' })}</Table.Cell>
//                            <Table.Cell collapsing>


//                                <Button
//                                    color="red"
//                                    icon='trash'
//                                    onClick={() => viewModel.openConfirmDialog(scale.id)}
//                                />

//                            </Table.Cell>
//                        </Table.Row>
//                    ))}
//                <Confirm
//                    header='!!!'
//                    content='Уверен?!!'
//                    cancelButton='Отмена'
//                    open={viewModel.confirmEnabled}
//                    onConfirm={async () => {
//                        await viewModel.deleteScale();
//                        await viewModel.fetchData();
//                        await viewModel.closeConfirmDialog();
//                    }}
//                    onCancel={viewModel.closeConfirmDialog} />
//            </Table.Body>
//            <Table.Footer fullWidth>
//                <Table.Row>
//                    <Table.HeaderCell colSpan="5">
//                        <Button
//                            primary
//                            fluid
//                            icon='plus'
//                            content="Добавить"
//                            onClick={async () => await viewModel.createScale()}
//                        />
//                    </Table.HeaderCell>
//                </Table.Row>
//            </Table.Footer>
//        </Table>

//        <Modal
//            closeIcon
//            onClose={() => viewModel.setModalEnabled(false)}
//            open={viewModel.modalOpened}
//            dimmer='blurring'>
//            <Modal.Header>{viewModel.modalHeader}</Modal.Header>
//            <Modal.Content>{viewModel.modalContent}</Modal.Content>
//        </Modal>
//    </div>
//)
//}

//export default observer(Scales);